import ZoomController from './src/ZoomController.vue';

ZoomController.install = function(Vue) {
  Vue.component(ZoomController.name, ZoomController);
}

export default ZoomController;